import type { AdPublic } from './types'

export async function fetchAd(zoneId: number): Promise<AdPublic | null> {
  try {
    const res = await fetch(`/api/ads/zone/${zoneId}`, { cache: 'no-store' })
    if (res.status === 204) return null
    if (!res.ok) return null
    return res.json() as Promise<AdPublic>
  } catch {
    return null
  }
}

export async function trackClick(adId: number): Promise<string | null> {
  try {
    const res = await fetch(`/api/ads/${adId}/click`, { method: 'POST' })
    if (!res.ok) return null
    const data = await res.json() as { redirect_url: string }
    return data.redirect_url
  } catch {
    return null
  }
}
